export default {
  menu: 'Purchases flow products',
  title: 'Purchases flow products',

  general: {
    status: {
      all: 'All',
      preInvoice: 'Draft',
      invoice: 'Invoice',
      receipt: 'Pull in',
      incomplete: 'Incomplete',
    },
  },

  list: {
    title: 'Purchases flow products'
  }
}
